import { emitAnalyticsEvent } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'

export function trackEvent(eventName: string, payload: object) {
  const emitedinMicro = emitAnalyticsEvent({ eventName, payload })
  if (!emitedinMicro) {
    useAnalyticService().trackEvent(eventName, payload)
  }
}
